import { useState } from "react";
import { useAuth } from "@/App";
import { useNavigate } from "react-router-dom";
import { SignIn } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "bg-[#1A1A1A] border border-white/10 rounded-md px-4 py-3 text-[#F2EFE9] placeholder:text-[#8C8C8C]/60 font-body text-sm focus:ring-1 focus:ring-[#D4AF37] focus:border-[#D4AF37] outline-none w-full";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <a href="/" className="font-heading text-3xl font-black tracking-tighter text-[#F2EFE9]">
            3<span className="text-[#D4AF37]">SM</span>
          </a>
          <p className="text-sm text-[#8C8C8C] font-body mt-2">Admin Dashboard</p>
        </div>
        <form onSubmit={handleSubmit} data-testid="admin-login-form" className="space-y-4">
          <input
            data-testid="admin-login-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
          />
          <input
            data-testid="admin-login-password"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputClass}
          />
          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm font-body">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#D4AF37] text-[#050505] font-bold px-8 py-3 rounded-md hover:bg-[#E5C158] transition-colors uppercase tracking-widest text-sm flex items-center justify-center gap-2 disabled:opacity-50"
          >
            <SignIn size={18} weight="bold" />
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="text-center mt-6">
          <a href="/" data-testid="admin-login-back" className="text-xs text-[#8C8C8C] hover:text-[#D4AF37] transition-colors font-body">
            &larr; Back to site
          </a>
        </p>
      </div>
    </div>
  );
}
